import { CSSProperties, ReactNode } from "react";
import { usePalette } from "@/shared/theme";

export function Footer({ children }: { children: ReactNode }) {
  const palette = usePalette();

  return (
    <div
      className={"py-5 flex justify-center border-t border-[--border-color]"}
      style={
        {
          "--border-color": palette.neutral[2],
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
